import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=af7be462&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7be462",
  null
  
)

export default component.exports